<template>
  <div class="main-wrapper">
    <div class="account-content">
      <div class="row login-wrapper m-0">
        <div class="col-lg-6 p-0">
          <div class="login-content">
            <form @submit.prevent="login">
              <div class="login-userset">
                <div class="login-logo logo-normal">
                  <img src="assets/img/otobonik-logo.png" alt="img">

                  <p class="login-slogan mb-0">
                    Manage your Business at your HOME.
                  </p>
                </div>
                <a href="index.html" class="login-logo logo-white">
                    <img src="assets/img/otobonik-logo.png"  alt="Img">
                </a>
                <div class="login-userheading">
                  <h3>Sign In</h3>
                  <h4>Access the Login panel using your username and password.</h4>
                </div>
                <div class="mb-3">
                  <label class="form-label">Username</label>
                  <div class="input-group">
                      <input type="text" v-model="username" class="form-control border-end-0">

                  </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Password</label>
                    <div class="pass-group">
                        <input type="password" v-model="password" class="pass-input form-control">
                        <span class="ti toggle-password ti-eye-off text-gray-9"></span>
                    </div>
                </div>
                <!-- Show error message -->
                <div v-if="errorMessage" class="alert alert-danger">
                  {{ errorMessage }}
                </div>

<!--                <div class="form-login authentication-check">-->
<!--                    <div class="row">-->
<!--                        <div class="col-6">-->
<!--                            <div class="custom-control custom-checkbox">-->
<!--                                <label class="checkboxs ps-4 mb-0 pb-0 line-height-1">-->
<!--                                    <input type="checkbox">-->
<!--                                    <span class="checkmarks"></span>Remember me-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-6 text-end">-->
<!--                            <a class="forgot-link" href="forgot-password-2.html">Forgot Password?</a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="form-login">
                    <button type="submit" class="btn btn-login">Sign In</button>
                </div>
<!--                <div class="signinform">-->
<!--                    <h4>New on our platform?<a href="register-2.html" class="hover-a"> Create an account</a></h4>-->
<!--                </div>-->
<!--                <div class="form-setlogin or-text">-->
<!--                    <h4>OR</h4>-->
<!--                </div>-->
                <div class="form-sociallink">
<!--                    <div class="d-flex align-items-center justify-content-center flex-wrap">-->
<!--                        <div class="text-center me-2 flex-fill">-->
<!--                            <a href="javascript:void(0);"-->
<!--                                class="br-10 p-2 btn btn-info d-flex align-items-center justify-content-center">-->
<!--                                <img class="img-fluid m-1" src="assets/img/icons/facebook-logo.svg" alt="Facebook">-->
<!--                            </a>-->
<!--                        </div>-->
<!--                        <div class="text-center me-2 flex-fill">-->
<!--                            <a href="javascript:void(0);"-->
<!--                                class="btn btn-white br-10 p-2  border d-flex align-items-center justify-content-center">-->
<!--                                <img class="img-fluid m-1" src="assets/img/icons/google-logo.svg" alt="Facebook">-->
<!--                            </a>-->
<!--                        </div>-->
<!--                        <div class="text-center flex-fill">-->
<!--                            <a href="javascript:void(0);"-->
<!--                                class="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center">-->
<!--                                <img class="img-fluid m-1" src="assets/img/icons/apple-logo.svg" alt="Apple">-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="my-4 d-flex justify-content-center align-items-center copyright-text">
                        <p> &copy; 2026 <a href="https://entrancelogic.com/" target="_blank" rel="noopener">Entrance Logic Systems</a></p>
                    </div>
                </div>
            </div>
            </form>
          </div>
        </div>
        <div class="col-lg-6 p-0">
            <div class="login-img">
                <img src="assets/img/authentication/authentication-01.png" alt="img">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from '../urls';
import { setPermissions } from '@/helpers/permission';

export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessage: "",
    };
  },

  methods: {
    async login() {
      try {
        const response = await this.$axios.post(apiUrls.user.login, {
          username: this.username,
          password: this.password,
        });

        // Extract backend data
        const token = response.data.token;
        const permissions = response.data.permissions || [];
        const role = response.data.role || [];
        const is_staff = response.data.is_staff;

        // Store everything in localStorage
        localStorage.setItem('auth_token', token);
        // Drop the previous user's store; the header picks this user's store after login.
        localStorage.removeItem('store_id');
        setPermissions(permissions);
        localStorage.setItem('role', JSON.stringify(role));
        localStorage.setItem('is_staff', is_staff);

        // Pick the store before the first page loads, so its requests already carry X-Store-ID.
        await this.selectInitialStore();

        // Redirect
        this.$router.push({ name: 'Home' });

      } catch (error) {
        console.error('Login failed', error);
        const detail =
          error?.response?.data?.detail ||
          error?.response?.data?.non_field_errors?.[0];
        this.errorMessage = detail || "Invalid username or password!";
      }
    },

    async selectInitialStore() {
      try {
        const [userRes, storesRes] = await Promise.all([
          this.$axios.get(apiUrls.login_user.get),
          this.$axios.get(apiUrls.stores.get),
        ]);
        const stores = storesRes.data || [];
        const assigned = stores.find(s => String(s.id) === String(userRes.data?.store));
        const store = assigned || stores[0];
        if (store) {
          localStorage.setItem('store_id', store.id);
        }
      } catch (e) {
        // The header picks a store on load as a fallback.
      }
    },
  },
};
</script>
